<template>
  <!-- ring-1 ring-black ring-opacity-5 -->
  <TableWrapper
    :title="props.title"
    :subtitle="props.subtitle"
    :no-top-padding="noTopPadding"
  >
    <template v-slot:button-slot>
      <div class="flex flex-row items-center space-x-2">
        <slot name="button-slot"> </slot>
      </div>
    </template>
    <template v-slot:tabs>
      <slot name="tabs"> </slot>
    </template>

    <template v-slot:above-table>
      <slot
        v-if="!props.loading && !_.isEmpty(data) && !_.isEmpty(columns)"
        name="above-table"
      >
      </slot>
    </template>

    <!-- <div class="shadow rounded-lg bg-white w-full"> -->
    <!-- overflow-auto  -->
    <div class="bg-white dark:bg-slate-900 rounded-lg w-full border">
      <table
        v-if="props.loading"
        class="animate-pulse w-full border-separate border-spacing-0 rounded-lg bg-white dark:bg-slate-900"
      >
        <thead>
          <tr>
            <th v-for="n in 6" :class="headerClass">
              <div class="h-2 bg-slate-300 dark:bg-slate-900 rounded"></div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="n in 5">
            <td
              v-for="n in 6"
              class="border-b border-gray-200 dark:border-gray-700 py-4 pl-4 pr-3 text-sm break-normal"
            >
              <div class="h-2 bg-slate-200 dark:bg-slate-700 rounded"></div>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-else-if="!_.isEmpty(data) && !_.isEmpty(columns)">
        <table
          :class="[
            'w-full border-separate border-spacing-0 rounded-lg bg-white  dark:bg-slate-900 ',
          ]"
        >
          <thead class="">
            <tr v-if="columnGroups">
              <th
                v-for="group in columnGroups"
                :colspan="group.columns"
                :class="[
                  headerClass.replace('font-semibold', 'font-normal'),
                  'uppercase ',
                ]"
              >
                {{ group.label }}
              </th>
            </tr>

            <tr class="rounded-lg">
              <!-- sticky -->
              <th
                v-if="props.withSelection"
                scope="col"
                :class="headerClass"
              ></th>
              <!-- sticky header with backdrop blur from https://tailwindui.com/components/application-ui/lists/tables#component-6e8d7d4ca9657a86da779b7af9a1de2c -->
              <th
                v-if="props.rowIcon"
                scope="col"
                :class="[
                  props.dense ? 'py-3 pl-3 pr-2' : 'py-4 pl-4 pr-3',
                  headerClass,
                ]"
              ></th>
              <!-- bg-white bg-opacity-75  -->
              <th
                scope="col"
                :class="[props.dense ? ' py-3 pl-3 pr-2' : '', headerClass]"
                v-for="(column, columnIdx) in columns"
                :key="columnIdx"
              >
                <div class="flex flex-row">
                  <span style="text-transform: capitalize">
                    {{
                      column == "href"
                        ? ""
                        : column.replaceAll("time_", "").replaceAll("_", " ")
                    }}
                  </span>
                </div>
              </th>
              <th
                v-if="props.clickable"
                scope="col"
                :class="[
                  props.dense ? 'py-1.5 pl-3 pr-2' : 'py-4 pl-4 pr-3',
                  headerClass,
                ]"
              ></th>
            </tr>
            <tr
              v-if="
                selectedItems.length > 0 &&
                !_.isEmpty(slots['selection-header'])
              "
            >
              <td :colspan="columns.length + 2" class="border-b p-4">
                <slot name="selection-header"></slot>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, rowIdx) in data"
              :key="rowIdx"
              :class="[
                'href' in row || (props.clickable && row.clickable != false)
                  ? 'hover:bg-gray-50 dark:hover:bg-slate-700 cursor-pointer'
                  : 'hover:bg-gray-50/50 dark:hover:bg-slate-700/90',
                // selectedItems.includes(row.id) || selectedRow == row.id
                //   ? 'bg-teal-500/5'
                //   : '',
              ]"
              @click="if (row.clickable != false) open(row, rowIdx);"
            >
              <td
                v-if="props.withSelection"
                class="relative px-7 sm:w-12 sm:px-6 border-b border-gray-200 dark:border-gray-700"
              >
                <div
                  v-if="selectedItems.includes(row.id)"
                  class="absolute inset-y-0 left-0 w-0.5 bg-primary"
                ></div>
                <input
                  type="checkbox"
                  class="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 dark:border-gray-600 text-primary focus:ring-primary"
                  :value="row.id"
                  v-model="selectedItems"
                  @click.stop=""
                  @change="emit('update:selectedItems', selectedItems)"
                />
              </td>
              <td
                v-if="props.rowIcon"
                :class="[
                  rowIdx !== data.length - 1
                    ? 'border-b border-gray-200 dark:border-gray-700'
                    : '',
                  'break-normal py-4 pl-4 pr-3 text-sm ',
                ]"
              >
                <RectangleStackIcon
                  v-if="props.rowIcon == 'rectangle-stack'"
                  class="h-5 w-5 text-gray-500"
                  aria-hidden="true"
                />
                <DocumentCheckIcon
                  v-if="props.rowIcon == 'document-check'"
                  class="h-5 w-5 text-gray-500"
                  aria-hidden="true"
                />
              </td>
              <td
                v-for="(column, columnIdx) in columns"
                :key="columnIdx"
                :class="[
                  rowIdx !== data.length - 1
                    ? 'border-b border-gray-200 dark:border-gray-700'
                    : '',
                  // 1st column bold
                  columnIdx <
                  (props.numColumnsBold != undefined ? props.numColumnsBold : 1)
                    ? 'font-medium text-gray-900 dark:text-gray-100'
                    : 'text-gray-700 dark:text-gray-300',
                  props.dense ? 'py-1.5 pl-3 pr-2' : 'py-3 px-3',
                  'break-normal  text-sm ',
                ]"
              >
                <!-- href column -->
                <div v-if="column == 'href' && row[column]">
                  <router-link :to="row[column]" class="text-primary">
                    <ChevronRightIcon class="h-5 w-5" aria-hidden="true" />
                  </router-link>
                </div>

                <div
                  v-else-if="
                    typeof row[column] == 'object' &&
                    !_.isEmpty(row[column]?.displayAs) &&
                    row[column].displayAs == 'chart'
                  "
                  class="h-8 w-40 flex flex-row items-center"
                >
                  <div class="w-12 mr-2">
                    <Score :score="row[column].avg" />
                  </div>

                  <div class="w-24 h-8">
                    <BarChart
                      :data="row[column].value"
                      :options="{
                        responsive: true,
                        maintainAspectRatio: false,
                        indexAxis: 'y',
                        plugins: {
                          legend: {
                            display: false,
                          },
                          tooltip: {
                            enabled: false,
                          },
                        },
                        scales: {
                          y: {
                            stacked: true,
                            display: false,
                            // ticks: {
                            //   display: false,
                            // },
                            // grid: {
                            //   display: false,
                            // },
                          },
                          x: {
                            stacked: true,
                            display: false,
                            // ticks: {
                            //   display: false,
                            // },
                            // grid: {
                            //   display: false,
                            // },
                          },
                        },
                      }"
                    />
                  </div>
                </div>

                <div
                  v-else-if="
                    typeof row[column] == 'object' &&
                    !_.isEmpty(row[column]?.displayAs) &&
                    row[column].displayAs == 'link'
                  "
                >
                  <button
                    @click.stop="row[column].action"
                    :class="[
                      row[column].kind == 'action-button'
                        ? 'ring-1 ring-primary text-primary font-medium hover:bg-primary hover:text-white'
                        : 'hover:bg-primary-bg ',
                      ' flex flex-row space-x-2 text-left rounded-lg p-2 -my-2',
                    ]"
                  >
                    <span class="flex-none"> {{ row[column].label }} </span>
                    <span
                      v-if="row[column].sublabel"
                      class="grow font-normal text-gray-500"
                    >
                      {{ row[column].sublabel }}
                    </span>
                    <ArrowTopRightOnSquareIcon
                      v-if="_.isUndefined(row[column].kind)"
                      class="flex-none h-4 w-4 text-primary"
                    />
                  </button>
                </div>

                <div
                  v-else-if="
                    typeof row[column] == 'object' &&
                    !_.isEmpty(row[column]?.displayAs) &&
                    row[column].displayAs == 'array-list'
                  "
                  class="gap-2 w-full flex flex-wrap"
                >
                  <!-- display as tags -->
                  <span
                    v-for="v in row[column].value"
                    class="rounded-md ring-1 ring-gray-300 bg-teal-500/5 p-1 text-xs"
                  >
                    {{ v }}
                  </span>
                </div>

                <div
                  v-else-if="
                    typeof row[column] == 'object' &&
                    !_.isEmpty(row[column]?.displayAs) &&
                    row[column].displayAs == 'object-list'
                  "
                  class="space-y-2"
                >
                  <div
                    v-for="(v, k) in row[column].value"
                    class="flex flex-col"
                  >
                    <span class="text-gray-400 uppercase text-xs">{{ k }}</span>

                    <div v-if="row[column].editable" class="">
                      <ContentEditable
                        v-model="row[column].value[k]"
                        value-classes="text-xs !p-2 !focus:ring-1 sm:leading-normal"
                        @click.stop
                        @input="row[column].onInput"
                        min-height="20px"
                      />
                    </div>

                    <!-- line-clamp-3 -->
                    <span v-else class="text-gray-600">
                      {{ v }}
                    </span>
                  </div>
                </div>

                <div
                  v-else-if="
                    typeof row[column] == 'object' &&
                    !_.isEmpty(row[column]?.displayAs) &&
                    row[column].displayAs == 'tag'
                  "
                  class="flex space-x-1"
                >
                  <component
                    :is="row[column].icon"
                    class="h-5 w-5"
                    :class="
                      row[column].color ? 'text-' + row[column].color : ''
                    "
                  />
                  <!-- rounded-md ring-1 ring-gray-300 p-1  -->
                  <span :class="['capitalize']">
                    {{ row[column].value }}
                  </span>
                </div>
                <div
                  v-else-if="
                    typeof row[column] == 'object' &&
                    !_.isEmpty(row[column]?.displayAs) &&
                    row[column].displayAs == 'icon-number'
                  "
                  class=""
                >
                  <div
                    v-if="row[column].value > 0"
                    :class="[
                      'flex flex-row space-x-2 rounded-md ring-1 ring-gray-300 w-min p-1 bg-gray-50',
                      row[column].color ? 'text-' + row[column].color : '',
                    ]"
                  >
                    <!-- <ChatBubbleLeftRightIcon
                      class="h-5 w-5"
                      v-if="row[column].icon == 'ChatBubbleLeftRightIcon'"
                    />
                    <RectangleStackIcon
                      class="h-5 w-5"
                      v-else-if="row[column].icon == 'RectangleStackIcon'"
                    />
                    <BeakerIcon
                      class="h-5 w-5"
                      v-else-if="row[column].icon == 'BeakerIcon'"
                    /> -->

                    <!-- TODO this should work -->
                    <component :is="row[column].icon" class="h-5 w-5" />
                    <span>
                      {{ row[column].value }}
                    </span>
                  </div>
                  <div v-else>
                    <MinusIcon class="h-5 w-5" />
                  </div>
                </div>

                <!-- rubric column -->
                <div
                  v-else-if="
                    typeof row[column] == 'object' &&
                    !_.isEmpty(row[column]?.displayAs) &&
                    row[column].displayAs == 'rubric'
                  "
                >
                  <Score :score="row[column].value" />
                </div>

                <!-- diff -->
                <!-- <div
                  v-else-if="
                    typeof row[column] == 'object' &&
                    !_.isEmpty(row[column]?.displayAs) &&
                    row[column].displayAs == 'diff'
                  "
                >
                  <Diff
                    :prev="row[column].old"
                    :current="row[column].new"
                    theme="light"
                  />
                </div> -->

                <!-- <div
                  v-else-if="Array.isArray(row[column])"
                  class="flex flex-row space-x-2"
                >
                  <div
                    class="ring-primary ring-1 text-xs text-primary p-1 w-min rounded capitalize"
                    v-for="val in row[column]"
                  >
                    {{ val }}
                  </div>
                </div> -->

                <div
                  v-else-if="
                    !_.isEmpty(row[column]) &&
                    typeof row[column] == 'object' &&
                    !_.isEmpty(row[column].message)
                  "
                  class="flex flex-row space-x-2"
                >
                  <CheckCircleIcon
                    v-if="row[column].status"
                    class="h-5 w-5 text-green-500"
                  />
                  <ExclamationTriangleIcon
                    v-else
                    class="h-5 w-5 text-yellow-500"
                  />
                  <div>
                    {{ row[column].message }}
                  </div>
                </div>
                <div v-else-if="column == 'actions'">
                  <button
                    type="button"
                    :class="[
                      ' hover:ring-1 ring-gray-300 hover:bg-white text-' +
                        action.color,
                      // ' hover:text-white hover:bg-' + action.color,
                      ' -m-1 p-1 inline-flex items-center border border-transparent text-md font-normal rounded-md capitalize',
                    ]"
                    v-for="action in row[column]"
                    @click.stop="action.action()"
                  >
                    <component
                      v-if="action.icon"
                      :is="action.icon"
                      class="h-5 w-5"
                    />
                    <span v-if="action.label" class="mr-1">
                      {{ action.label }}
                    </span>
                  </button>
                </div>
                <div
                  v-else-if="
                    !_.isEmpty(row[column]) && Array.isArray(row[column])
                  "
                  class="flex flex-row space-x-2 items-center"
                >
                  <ul class="list-disc list-inside">
                    <li v-for="val in row[column]">{{ val }}</li>
                  </ul>
                </div>
                <div
                  v-else-if="
                    !_.isEmpty(row[column]) &&
                    typeof row[column] == 'object' &&
                    !_.isUndefined(row[column].values)
                  "
                  class="flex flex-row space-x-2 items-center"
                >
                  <div
                    class="ring-gray-700 text-gray-700 ring-1 text-xs p-1 w-min h-min rounded capitalize"
                    v-for="val in row[column].values"
                  >
                    {{ val }}
                  </div>
                  <button
                    type="button"
                    class="p-1 inline-flex items-center border border-transparent text-xs font-medium rounded-md text-primary hover:bg-white hover:ring-1 hover:ring-primary capitalize"
                    v-for="action in row[column].actions"
                    @click.stop="emit('action', action, row)"
                  >
                    {{ action.replaceAll("_", " ") }}
                  </button>
                </div>

                <div v-else-if="column.startsWith('time_')">
                  {{ new Date(row[column]).toLocaleString() }}
                </div>

                <!-- default -->
                <div
                  v-else-if="
                    row[column]?.displayAs == 'value' && row[column]?.editable
                  "
                >
                  <ContentEditable
                    v-model="row[column].value"
                    value-classes="text-xs !p-2 !focus:ring-1 sm:leading-normal"
                    @click.stop
                    @input="row[column].onInput"
                    min-height="20px"
                  />
                </div>

                <!-- line-clamp-3  -->
                <div v-else :class="[unlimited ? '' : 'max-w-[10rem] ']">
                  {{ formatValue(row[column]) }}
                </div>
              </td>

              <!-- if clickable -->
              <td
                v-if="props.clickable"
                :class="[
                  rowIdx !== data.length - 1
                    ? 'border-b border-gray-200 dark:border-gray-700'
                    : '',
                  'break-normal py-4 pl-4 pr-3 text-sm ',
                ]"
              >
                <ChevronRightIcon
                  v-if="row.clickable != false"
                  class="h-5 w-5 text-primary"
                  aria-hidden="true"
                />
              </td>
            </tr>
          </tbody>
        </table>

        <!-- {{ paginationSettings }} -->
        <!-- values: total (num rows), page (current), pages (total), size -->
        <div v-if="pagination">
          <div
            class="flex items-center justify-between border-t border-gray-200 dark:border-gray-600 p-3 rounded-b-lg"
          >
            <div class="flex flex-1 justify-between sm:hidden">
              <a
                href="#"
                class="relative inline-flex items-center rounded-md border border-gray-300 dark:border-gray-600 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
                >Previous</a
              >
              <a
                href="#"
                class="relative ml-3 inline-flex items-center rounded-md border border-gray-300 dark:border-gray-600 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
                >Next</a
              >
            </div>
            <div
              class="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between"
            >
              <div>
                <p class="text-sm text-gray-500 font-normal">
                  Showing
                  {{ " " }}
                  <span class="font-medium">
                    {{
                      paginationSettings.size * (paginationSettings.page - 1) +
                      1
                    }}
                  </span>
                  {{ " " }}
                  to
                  {{ " " }}
                  <span class="font-medium">{{
                    Math.min(
                      paginationSettings.size * paginationSettings.page,
                      paginationSettings.total
                    )
                  }}</span>
                  {{ " " }}
                  of
                  {{ " " }}
                  <span class="font-medium">{{
                    paginationSettings.total
                  }}</span>
                  {{ " " }}
                  results
                </p>
              </div>
              <div class="flex flex-1 justify-between sm:justify-end">
                <button
                  @click="emit('selectPage', 1)"
                  :class="[
                    paginationSettings.page == 1
                      ? 'bg-gray-100 dark:bg-slate-700 text-gray-400'
                      : 'bg-white dark:bg-slate-900 text-gray-900 dark:text-gray-300',
                    'relative inline-flex items-center rounded-md px-3 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-offset-0',
                  ]"
                  :disabled="paginationSettings.page == 1"
                >
                  First
                </button>
                <button
                  @click="emit('selectPage', paginationSettings.page - 1)"
                  :class="[
                    paginationSettings.page == 1
                      ? 'bg-gray-100 dark:bg-slate-700 text-gray-400'
                      : 'bg-white dark:bg-slate-900 text-gray-900 dark:text-gray-300',
                    'relative ml-3 inline-flex items-center rounded-md px-3 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-offset-0',
                  ]"
                  :disabled="paginationSettings.page == 1"
                >
                  Previous
                </button>
                <button
                  @click="emit('selectPage', paginationSettings.page + 1)"
                  :class="[
                    paginationSettings.page == paginationSettings.pages
                      ? 'bg-gray-100 dark:bg-slate-700 text-gray-400'
                      : 'bg-white dark:bg-slate-900 text-gray-900 dark:text-gray-300',
                    'relative ml-3 inline-flex items-center rounded-md px-3 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-offset-0',
                  ]"
                  :disabled="
                    paginationSettings.page == paginationSettings.pages
                  "
                >
                  Next
                </button>
                <button
                  @click="emit('selectPage', paginationSettings.pages)"
                  :class="[
                    paginationSettings.page == paginationSettings.pages
                      ? 'bg-gray-100 dark:bg-slate-700 text-gray-400'
                      : 'bg-white dark:bg-slate-900 text-gray-900 dark:text-gray-300',
                    'relative ml-3 inline-flex items-center rounded-md px-3 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-offset-0',
                  ]"
                  :disabled="
                    paginationSettings.page == paginationSettings.pages
                  "
                >
                  Last
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else>
        <div v-if="slots.empty">
          <slot name="empty"> </slot>
        </div>

        <div v-else class="flex p-4">
          <div class="text-gray-400">No data to display</div>
        </div>
      </div>
    </div>
  </TableWrapper>
</template>

<script setup lang="ts">
import { ArrowLongLeftIcon, ArrowLongRightIcon } from "@heroicons/vue/20/solid";
import {
  ArrowTopRightOnSquareIcon,
  ChatBubbleLeftRightIcon,
  CheckCircleIcon,
  ChevronDoubleRightIcon,
  ChevronDownIcon,
  ChevronRightIcon,
  DocumentCheckIcon,
  ExclamationTriangleIcon,
  ExclamationCircleIcon,
  MinusIcon,
  RectangleGroupIcon,
  RectangleStackIcon,
  XCircleIcon,
  ChevronLeftIcon,
} from "@heroicons/vue/24/outline";
import { computed, ref, watch } from "vue";
import { useRouter } from "vue-router";
import TableWrapper from "./TableWrapper.vue";
import _ from "underscore";
import { useSlots } from "vue";
import Spinner from "./utils/Spinner.vue";
import { useStore } from "@/store";
import BarChart from "@/charts/BarChart.vue";
import Score from "./utils/Score.vue";
import { BeakerIcon } from "@heroicons/vue/24/solid";
import ContentEditable from "./utils/ContentEditable.vue";

// import VueDiff from "vue-diff";
// import "vue-diff/dist/index.css";

const headerClass =
  "sticky top-0 z-10 bg-gray-50 dark:bg-slate-900 border-b rounded-t-lg border-gray-300 dark:border-gray-600 py-3 px-3 text-left text-sm text-gray-700 dark:text-gray-300 font-medium  ";

// class="divide-x divide-gray-200"

const slots = useSlots();
const router = useRouter();

const props = defineProps([
  "data",
  "computeColumnsFromAllRows",
  "hideColumns",
  "title",
  "subtitle",
  "clickable",
  "deletable",
  "numColumnsBold",
  "rowIcon",
  "dense",
  "loading",
  "withSelection",
  "initialSelectedItems",
  "selectedRow",
  "columnGroups",
  "unlimited",
  "equalWidth",
  "pagination",
  "paginationSettings",
  "noTopPadding",
]);

const hideColumnsDefault = ref([
  "id",
  "prompt_version_id",
  "prompt_id",
  "deployment_stage_raw",
  "clickable",
  "route",
  // "Helpfulness",
]);

const hideColumns = computed(() => {
  if (props.hideColumns) {
    return hideColumnsDefault.value.concat(props.hideColumns);
  }
  return hideColumnsDefault.value;
});

const emit = defineEmits([
  "clickRow",
  "action",
  "update:selectedItems",
  "selectPage",
]);

const columnsThatGoLast = ["actions", "time_created", "time_updated"];

const columns = computed(() => {
  if (_.isEmpty(props.data) || props.data.length === 0) {
    return [];
  }

  if (props.computeColumnsFromAllRows) {
    // take all rows
    let cols = _.chain(props.data)
      .map((row) => Object.keys(row))
      .flatten()
      .uniq()
      .value()
      .filter((c) => !hideColumns.value.includes(c));

    // move columnsThatGoLast to the end
    cols = _.sortBy(cols, (c) => {
      if (columnsThatGoLast.includes(c)) {
        return 1;
      }
      return 0;
    });

    return cols;
  } else {
    // take first row
    let cols = Object.keys(props.data[0]).filter(
      (c) => !hideColumns.value.includes(c)
    );
    // move columnsThatGoLast to the end
    cols = _.sortBy(cols, (c) => {
      if (columnsThatGoLast.includes(c)) {
        return 1;
      }
      return 0;
    });
    return cols;
  }
});

const selectedItems = ref(props.initialSelectedItems || []);
watch(
  () => props.initialSelectedItems,
  (value) => {
    selectedItems.value = value;
  }
);

function open(row, rowIdx) {
  if ("href" in row) {
    router.push(row.href);
  } else if (props.clickable) {
    emit("clickRow", row, rowIdx);
  }
}

function formatValue(val) {
  if (typeof val === "number") {
    return Math.round((val + Number.EPSILON) * 100) / 100;
  }
  return val;
}
</script>
